import { render, staticRenderFns } from "./SideFilter.vue?vue&type=template&id=0ad8b8fb"
import script from "./SideFilter.vue?vue&type=script&lang=js"
export * from "./SideFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports